import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CommonService } from '../../services/common.service';

/**
 * Generated class for the CommentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 @IonicPage()
 @Component({
 	selector: 'page-comment',
 	templateUrl: 'comment.html',
 })
 export class CommentPage {
 	customersComments=[];
 	commentStatistics={good:0,ok:0,bad:0};	
 	constructor(public navCtrl: NavController, public navParams: NavParams,public commonService:CommonService) {
 	}

 	ionViewDidLoad() {
 		this.getCustomersComments();
 	}


 	public getCustomersComments(){

 		this.commonService.showLoading();
 		this.commonService.getCustomersComments().subscribe(success => {
 			this.commonService.dismisshowoading();
 			if (success && success.status=="success") {

 				this.customersComments=success.data;
 				this.getCommentStatistics(this.customersComments);
 				
 				
 			} else {
 				this.commonService.showPopup("No Data", success.message);
 			}
 		},error=>{
 			this.commonService.dismisshowoading();
 		});
 	}

 	getClassAccordingWords=function(commentText){

 		if (commentText.toLowerCase().match(/(bad|worst|disgusting|poor|awful|broken|boring|corrupt|creepy|cruel|depressed|dirty|dishonorable|dreadful|faulty|fake|ghastly|horrible|hurt|hurtful|imperfect|immature|malicious|nasty|nonsense|noxious|nondescript|pessimistic|poisonous|rude|rotten|repulsive|sad|not satisfied|not tasty|not good|not working|not functioning|not running|not understand|n't understand|scary|sick|stupid|stressful|terrible|terrifying|threatening|ugly|unfair|unhappy|unsatisfactory|unhealthy|upset|unusable|weird|waste|wicked|woeful|aweful|worthless|yucky)/)){
 			return "box red cursor-pointer";
 		} else if(commentText.toLowerCase().match(/(nice|awesome|great|enjoyed|wonderful|superb|excellent|lovely|pretty|delight|divine|elegant|amazing|adventure|creative|cheerful|divine|dazzling|exciting|effective|energetic|excellent|fabulous|fun|loving|fantastic|genius|genuine|graceful|healthy|intelligent|joy|kind|productive|pleasurable|pleasant|proud|special|stunning|satisfied|truthful|worthy|wealthy|yummy)/)){
 			return "box green cursor-pointer" 
 		}else {
 			return "box blue cursor-pointer";
 		}


 	}

 	getCommentStatistics=function(allComment){

 		allComment.forEach((commentText, index) => {
 			if (commentText.comment.toLowerCase().match(/(bad|worst|disgusting|poor|awful|broken|boring|corrupt|creepy|cruel|depressed|dirty|dishonorable|dreadful|faulty|fake|ghastly|horrible|hurt|hurtful|imperfect|immature|malicious|nasty|nonsense|noxious|nondescript|pessimistic|poisonous|rude|rotten|repulsive|sad|not satisfied|not tasty|not good|not working|not functioning|not running|not understand|n't understand|scary|sick|stupid|stressful|terrible|terrifying|threatening|ugly|unfair|unhappy|unsatisfactory|unhealthy|upset|unusable|weird|waste|wicked|woeful|aweful|worthless|yucky)/)){
 				this.commentStatistics.bad+=1;
 			} else if(commentText.comment.toLowerCase().match(/(nice|awesome|great|enjoyed|wonderful|superb|excellent|lovely|pretty|delight|divine|elegant|amazing|adventure|creative|cheerful|divine|dazzling|exciting|effective|energetic|excellent|fabulous|fun|loving|fantastic|genius|genuine|graceful|healthy|intelligent|joy|kind|productive|pleasurable|pleasant|proud|special|stunning|truthful|worthy|wealthy|yummy)/)){
 				this.commentStatistics.good+=1;
 				
 			}else {
 				this.commentStatistics.ok+=1;
 				
 			}

 		});

 		var totalComments=allComment.length;
 		this.commentStatistics.bad=(this.commentStatistics.bad/totalComments)*100;
 		this.commentStatistics.good=(this.commentStatistics.good/totalComments)*100;
 		this.commentStatistics.ok=(this.commentStatistics.ok/totalComments)*100;

 		this.commentStatistics.bad=this.commentStatistics.bad.toFixed();
 		this.commentStatistics.ok=this.commentStatistics.ok.toFixed();
 		this.commentStatistics.good=this.commentStatistics.good.toFixed(); 		

 	}

 	public viewCustomerFeedback(data){
          this.navCtrl.setRoot('RatingPage', {showCustomerFeedback:data});
 	}


 }



// WEBPACK FOOTER //
// ./src/pages/comment/comment.ts